import script from "./ProviderPoliciesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderPoliciesView.vue?vue&type=script&setup=true&lang=js"

import "../assets/provider-view.css?vue&type=style&index=0&id=f33c69b8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f33c69b8"]])

export default __exports__